import React from 'react';
import { Row, Col } from 'antd';
import Debug from './shared/Debug';
import { usePersistedStore } from '../store/persisted-store';
import GridSizeToggle from './GridSizeToggle';
import CategorySelect from './CategorySelect';
import { TOOL_CATEGORIES } from '../data/toolCategories';

const Content = ({
    children,
    Title,
    showSearch,
    searchTerm,
    onSearchChange,
    showGridToggle,
    gridCols,
    onGridColsChange,
    showCategoryFilter,
    selectedCategory,
    onCategoryChange,
}) => {
    const { auth } = usePersistedStore();
    const userInfo = auth.userInfo;
    return (
        <div className="main-content">
            <div className="page-content" style={{ display: 'flex', flexDirection: 'column', minHeight: '115vh' }}>
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-flex align-items-center justify-content-between">
                            <h4 className="page-title mb-0 font-size-18">{Title}</h4>
                            <div className="page-title-right d-flex align-items-center">
                                {showSearch && (
                                    <div className="page-title-search d-flex align-items-center">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="جستجوی ابزارها..."
                                            value={searchTerm}
                                            onChange={(e) => onSearchChange?.(e.target.value)}
                                        />
                                        {showCategoryFilter && (
                                            <CategorySelect
                                                value={selectedCategory}
                                                onChange={onCategoryChange}
                                                options={[
                                                    { value: 'all', label: 'همه دسته‌ها' },
                                                    ...TOOL_CATEGORIES.map(cat => ({ value: cat, label: cat })),
                                                ]}
                                            />
                                        )}
                                        {showGridToggle && (
                                            <GridSizeToggle
                                                gridCols={gridCols}
                                                onChange={onGridColsChange}
                                            />
                                        )}
                                    </div>
                                )}
                                <ol className="breadcrumb m-0">
                                    {/* <li className="breadcrumb-item active">خوش آمدید</li> */}
                                </ol>
                            </div>
                        </div>
                    </div>
                    {userInfo &&
                        userInfo.Resources &&
                        userInfo.Resources.includes('debugger') && <Debug />}
                </div>
                {children}
            </div>
            <footer className="footer ">
                <div className="container-fluid">
                    <div className="row">
                        <div className="copy-right">
                            <div className="copy-right-container">
                                <Row>
                                    <Col>
                                        <span className="content-cr" style={{ margin: "0 auto" }}>
                                            کلیه حقوق این سایت متعلق به شرکت <a href="/"> رایکا </a> است.
                                        </span>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}
export default Content;